import React from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function Projects() {
  const projects = [
    {
      title: 'Строим мой новый домик',
      description: 'Проект, в котором дети учатся создавать свои собственные миры.',
      link: '/projects/house',
      img: '/house.jpg' // TODO: Пожалуйста, поместите изображение для проекта 'Строим мой новый домик' в папку public и укажите здесь имя файла.
    },
    {
      title: 'Приключения Незнайки',
      description: 'Иллюстрации по мотивам знаменитой книги.',
      link: '/projects/neznayka',
      img: '/priklyucheniya-neznajki/20250927_105025.jpg'
    },
    {
      title: 'Гарри Поттер и тайная комната',
      description: 'Волшебный мир Гарри Поттера глазами наших учеников.',
      link: '/projects/harrypotter',
      img: '/projects/harry-potter/20250930_110153.jpg'
    }
  ];

  return (
    <Container className="mt-4">
      <h1>Наши проекты</h1>
      <p>Творческие миры, созданные нашими учениками.</p>
      <hr />
      <Row>
        {projects.map((project, index) => (
          <Col md={4} key={index} className="mb-4">
            <Card>
              <Card.Img variant="top" src={project.img} />
              <Card.Body>
                <Card.Title>{project.title}</Card.Title>
                <Card.Text>{project.description}</Card.Text>
                <Link to={project.link} className="btn btn-primary">Смотреть проект</Link>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default Projects;